import React, { useMemo, useState } from "react";
import { Modal } from "../Modal";
import { BlockForm } from "./BlockForm";
import { getValue } from "../../utils/object.utils";
import { useEditBlock } from "../../hooks/blockHooks/block.hooks";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
  setWarningMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";

interface Props {
  selectedBlock: any;
  open: boolean;
  onClose: () => unknown;
}
export const EditBlockModal = ({ selectedBlock, open, onClose }: Props) => {
  const dispatch = useDispatch();

  const [blockName, setBlockName] = useState("");
  const [schoolBranchId, setSchoolBranchId] = useState<number | null>(null);

  const { isLoading: isUpdatingBlock, mutate: updateBlock } = useEditBlock({
    onSuccess: () => {
      dispatch(setSuccessMessage("Block updated successfully."));
      onClose();
    },
    onError: (error: Error) => {
      dispatch(setErrorMessage(parseApiError(error)));
    },
  });

  const handleBlockUpdate = () => {
    if (!blockName) {
      return dispatch(setWarningMessage("Please enter block name"));
    }

    if (!schoolBranchId) {
      return dispatch(setWarningMessage("Please select branch."));
    }

    const blockId = getValue(selectedBlock, "id");

    if (!blockId) return null;

    updateBlock({
      blockId,
      body: {
        name: blockName,
        school_branch_id: schoolBranchId as number,
      },
    });
  };

  useMemo(() => {
    const blockName = getValue(selectedBlock, "name", "");
    const branchId = getValue(selectedBlock, "branchId");

    setBlockName(blockName);
    setSchoolBranchId(branchId);
  }, [selectedBlock]);

  return (
    <Modal
      show={open}
      onClose={onClose}
      modalHeader="Edit block"
      submissionButton={{
        text: "Save",
        onClick: () => {
          handleBlockUpdate();
        },
        isSubmitLoading: isUpdatingBlock,
      }}
    >
      <BlockForm
        blockName={blockName}
        setBlockName={setBlockName}
        schoolBranchId={schoolBranchId}
        onBranchSelect={setSchoolBranchId}
      />
    </Modal>
  );
};
